export default __webpack_public_path__ + "static/media/costEffective.1dca24da.svg";